import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Icon, IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface CommentComposerIconProps {
  iconName: IconName;
  isDisabled?: boolean;
  hasHover?: boolean;
  renderTooltip?: Renderer;
}

/*
 * Style.
 */

interface IconStyleProps {
  $isDisabled?: boolean;
  $hasHover?: boolean;
}
const StyledIconDiv = styled.div<IconStyleProps>`
  margin: 0 1px;
  padding: 4px;
  border-radius: 12px;

  ${(p) => maybeAddHoverStyle(p)}
`;

function maybeAddHoverStyle(props: IconStyleProps) {
  if (props.$isDisabled) {
    return undefined;
  }

  if (props.$hasHover) {
    return css`
      background-color: ${(p) => p.theme.alphas.black30};
    `;
  }

  return css`
    &:hover {
      background-color: ${(p) => p.theme.alphas.black30};
    }
  `;
}

/*
 * Component.
 */

export const CommentComposerIcon: FC<CommentComposerIconProps> = (props) => {
  const theme = useUserTheme();
  const enabledColor = theme.greys.shade80;
  return (
    <TooltipCoordinator hideOnMouseDown render={props.renderTooltip}>
      <StyledIconDiv $isDisabled={props.isDisabled} $hasHover={props.hasHover}>
        <Icon
          name={props.iconName}
          isDisabled={props.isDisabled}
          hasHover={props.hasHover}
          color={props.isDisabled ? theme.greys.shade40 : enabledColor}
          hoverColor={theme.greys.shade80}
          size={16}
        />
      </StyledIconDiv>
    </TooltipCoordinator>
  );
};
